const config = require('@sb/config')

export default {
	load: () => {
		if (config.env !== 'prod') return // facebook fixel
		!(function (f, b, e, v, n, t, s) {
			if (f.fbq) return
			n = f.fbq = function () {
				n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
			}
			if (!f._fbq) f._fbq = n
			n.push = n
			n.loaded = !0
			n.version = '2.0'
			n.queue = []
			t = b.createElement(e)
			t.async = !0
			t.src = v
			s = b.getElementsByTagName(e)[0]
			s.parentNode.insertBefore(t, s)
		})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')
		fbq('init', '1492184727660345')
		fbq('track', 'PageView')

		// google tag
		;(function (w, d, s, l, i) {
			w[l] = w[l] || []
			w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'})
			var f = d.getElementsByTagName(s)[0]
			var j = d.createElement(s)
			var dl = l != 'dataLayer' ? '&l=' + l : ''
			j.async = true
			j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl
			f.parentNode.insertBefore(j, f)
		})(window, document, 'script', 'dataLayer', 'GTM-M4K76T')
	},
	trackRoute: (to) => {
		if (config.env !== 'prod') return
		Array.isArray(window._fbq) && window._fbq.push(['track', 'PixelInitialized', {url: to.path}])
		Array.isArray(window.dataLayer) && window.dataLayer.push({event: 'pageview', page: {path: to.path}})
		if (!window.ga) return
		window.ga('set', 'page', to.path)
		window.ga('send', 'pageview')
	},
}
